import React, { useState, useRef } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import ShippingProviderReorderModal from 'components/admin/shipping-provider/ShippingProviderReorderModal';

import { adminShippingProviderApi } from 'api';

import {
  ADMIN_SHIPPING_PROVIDER_LIST_TAB,
  ADMIN_SHIPPING_PROVIDER_LIST_COLUMNS,
} from 'constants/admin/shipping-provider';

const ShippingProvider = () => {
  const tableRef = useRef();
  const [
    showShippingProviderReorderModal,
    setShowShippingProviderReorderModal,
  ] = useState(false);

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowShippingProviderReorderModal(true)}
    >
      Reorder
    </Button>
  );

  const handleActionSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Shipping Provider"
        apiService={adminShippingProviderApi}
        columns={ADMIN_SHIPPING_PROVIDER_LIST_COLUMNS}
        tabOptions={ADMIN_SHIPPING_PROVIDER_LIST_TAB}
        headerActions={headerActions}
      />

      <ShippingProviderReorderModal
        show={showShippingProviderReorderModal}
        onHide={() => setShowShippingProviderReorderModal(false)}
        onSuccess={handleActionSuccess}
      />
    </>
  );
};

export default ShippingProvider;
